import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import Coordinator from '../../models/Coordinator.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = () => {
  const navigate = useNavigate();
  const params = useParams();
  let coordinatorObj = new Coordinator({service_center_id: params.service_center_id});
  const [coordinator, setCoordinator] = useState(coordinatorObj.toStateJson());
  const [createApi] = getApi('createCoordinator');

  const createRecord = async (parameters) => {
    try {
      await createApi(parameters).unwrap();
      toast.success("Coordinator Created Successfully")
      navigate(`/service_centers/${params.service_center_id}`)
    } catch (error) {
      toast.error(error?.data?.message)
      coordinatorObj.set_api_errors(error?.data?.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord((new Coordinator(coordinator)).toApiJson());
    } catch(error) {
      setCoordinator(new Coordinator(coordinator));
    }
  }

  const handleCancelFunction = () => {
    navigate(`/service_centers/${params.service_center_id}`);
  }

  return <PageContentWrapper contentHeading={"Create New Coordinator"}>
    <div className='m-3'>
      <div className='mb-4 col-md-12'>
        <form className="row g-3" autoComplete="off">
          <FormPartial coordinator={coordinator} setCoordinator={setCoordinator} />
          <div className='mb-4 col-md-12'>
            <div >
              <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create Coordinator</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </PageContentWrapper>
}

export default New;
